package one.healthium.pcos.providers

import one.healthium.domain.paywall.PaywallIdProvider
import one.healthium.featureconfig.domain.CoreFeatureConfigKeys
import one.healthium.featureconfig.domain.FeatureConfigInteractor

class AppPaywallIdProvider(
    private val featureConfigInteractor: FeatureConfigInteractor,
) : PaywallIdProvider {

    override suspend fun getPaywallId(): String {
        return featureConfigInteractor.get(CoreFeatureConfigKeys.Paywall)
    }
}
